/**
 * The Ryoma voice in the report: a short line under each part's heading, in plain English.
 * A title in gold capitals, then what the part is about. Change a line here and every report follows.
 */
export interface Motto {
  title: string;
  line: string;
}

export const MOTTOS = {
  spend: { title: "Where you stand", line: "your shipping as it is today" },
  extra: { title: "Making it visible", line: "every charge set against the rate card" },
  save: { title: "One clean cut", line: "the savings, lever by lever" },
  plan: { title: "Change for the better", line: "up to 6 weeks, made with your team" },
  result: { title: "Checked at the source", line: "your costs before and after, with our fees included" },
  review: { title: "Checked", line: "line by line before it reached you" },
} satisfies Record<string, Motto>;

/** Company details for the report's closing page. Same as Ryoma-Website src/site.json. */
export const COMPANY = {
  legalName: "Ryoma Insight Ltd",
  email: "business@ryoma-insight.co.uk",
  web: "ryoma-insight.co.uk",
  companyNumber: "17141623",
  registeredIn: "England and Wales",
  registeredOffice: "131a Kingsman Street, London SE18 5PS",
};
